import dayjs from "dayjs";

import { DateFormat } from "@ctypes";

const MAX_AGE = 100;

export const createTargetAgeInputOptions = (dateOfBirth?: Date | null): string[] => {
  const age = dateOfBirth ? dayjs().diff(dayjs(dateOfBirth), "year") : 0;
  const numOfYears = Math.max(0, MAX_AGE - age);
  const options: string[] = [];

  for (let i = 0; i < numOfYears; i++) {
    options.push(dayjs().add(i, "year").format(DateFormat.Year));
  }

  return options;
};

export const calculateDefaultTargetYear = ({
  dateOfBirth,
  targetAge,
}: {
  dateOfBirth?: Date | null;
  targetAge?: number;
}): string => {
  const age = dateOfBirth ? dayjs().diff(dayjs(dateOfBirth), "year") : 0;

  if (age >= 18) {
    return dayjs().format(DateFormat.Year);
  }

  return dayjs(dateOfBirth ?? undefined)
    .add(targetAge ?? 0, "year")
    .format(DateFormat.Year);
};

export const calculateAgeByTargetYear = ({
  dateOfBirth,
  targetYear,
}: {
  dateOfBirth?: Date | null;
  targetYear: number;
}): number => {
  const dob = dateOfBirth ?? new Date();
  const dateYear = dayjs(dob).year();

  return targetYear - dateYear;
};
